import { createContext, useContext, useMemo } from 'react';
import type { FC, PropsWithChildren } from 'react';
import type { Product } from '../../bff-api/products/model';
import type { AssetInfo } from '../../components/photo-grid/utils';

interface ISSRProductContext {
    product?: Product;
    assets?: AssetInfo[];
}

const SSRProductContext = createContext<ISSRProductContext>({});

export const SSRProductProvider: FC<PropsWithChildren<ISSRProductContext>> = ({
    product,
    assets,
    children,
}) => {
    const ctx = useMemo(() => ({ product, assets }), [product, assets]);
    return <SSRProductContext.Provider value={ctx}>{children}</SSRProductContext.Provider>;
};

SSRProductProvider.defaultProps = {
    product: undefined,
    assets: [],
};

export const useSSRProduct = (): ISSRProductContext => {
    const ctx = useContext(SSRProductContext);
    if (!ctx) {
        throw new Error('useSSRProduct must be used within SSRProductProvider');
    }
    return ctx;
};
